var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "personalDetail" }, [
      _c("div", { staticClass: "content-box" }, [
        _c("h2", [_vm._v("自考乐【应用描述】")]),
        _c("p", { staticStyle: { "font-size": "14px" } }, [
          _vm._v(
            " 自考乐学习平台专注高校成人教育的移动应用，服务各大高职院校，提供从学习到考试、到学分认证，证书颁发的完整教学流程服务。平台提倡系统化的学习，旨在帮助用户获得全面、体系的知识和技能，实现学有所长，并能学以致用。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 自考乐专注服务自考助学人群，各位学子可通过自考乐学习自考助学院校的相关课程。一站解决自考听课学习、押题刷题和考试三大需求，帮助考生顺利高分通过自学考试。 "
          ),
        ]),
        _c("h2", { staticClass: "mat40" }, [_vm._v("【特色功能】")]),
        _c("strong", [_vm._v("【课程学习】")]),
        _c("br"),
        _vm._v("提供多种类型精品课程，自考学习知识点全覆盖。"),
        _c("br"),
        _vm._v(
          "高校教授、资深讲师授课、在线答疑，带您全面学习，提高学习效率，快速掌握重点、难点知识。"
        ),
        _c("br"),
        _c("strong", [_vm._v("【试题练习】")]),
        _c("br"),
        _vm._v("针对每章节的知识点出题，帮助学生更快掌握知识点。"),
        _c("br"),
        _c("strong", [_vm._v("【试卷练习】")]),
        _c("br"),
        _vm._v("历年真题、模拟考试、单元测试等等试卷，及时测试知识掌握情况。"),
        _c("br"),
        _c("strong", [_vm._v("【智能练习】")]),
        _c("br"),
        _vm._v(
          "海量题库，针对题型攻克，还可查看自己在学生中的排名，便于碎片时间的快速练习。"
        ),
        _c("br"),
        _c("strong", [_vm._v("【学习记录】")]),
        _c("br"),
        _vm._v(
          "记录您的错题记录，形成错题集再次练习，还可对知识点做笔记、收藏难题、重点题，全面检测自己的不足之处，再进行针对性的训练。 "
        ),
        _c("span", { staticStyle: { "font-size": "14px" } }),
      ]),
      _c("img", {
        staticClass: "personalDetail-background",
        attrs: { src: require("../../assets/images/个人中心图.png") },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }